<template>
  <v-content class="flags list page">
    <can I="list" a="Flag">
      <v-container>
        <v-toolbar flat class="transparent">
          <v-breadcrumbs
            class="pl-0"
            :items="[
              { exact: true, text: 'Admin', to: '/dashboard' },
              { exact: true, text: 'Flags', to: '/flags' },
            ]"
          >
            <v-icon slot="divider">mdi-chevron-right</v-icon>
          </v-breadcrumbs>

          <v-spacer />
        </v-toolbar>

        <v-card toolbar dark>
          <v-toolbar flat class="transparent">
            <v-card-title class="headline">
              Flags
            </v-card-title>
          </v-toolbar>

          <FlagList
            :value="active"
            :total="total"
            @refresh="filter"
            @paginate="event => filter(event)"
          />

        </v-card>
      </v-container>
    </can>
  </v-content>
</template>

<script>
// Components
import FlagList from '@/components/flags/List'

// Helpers
import _ from 'lodash'
import { mapState } from 'vuex'

// Mixins
import { managedQueryParameters } from '@/mixins/managedQueryParameters.js'

// Vue Component
export default {
  mixins: [managedQueryParameters],

  components: { FlagList },

  destroyed() {
    this.$store.commit('admin/flags/resetState')
  },

  data() {
    return {
      // Search and filters
      search: this.$route.query.search,
    }
  },

  computed: {
    ...mapState('admin/flags', ['active', 'loading', 'total', 'page', 'rowsPerPage']),
  },

  methods: {
    filter(payloadOrEvent) {
      // Update URL
      const filters = Object.assign({}, this.filters, { search: this.search })
      this.updateQueryParameters({ search: this.search, ...this.filters })
      // Fetch new data that matches filters and search
      this.$store.dispatch(
        'admin/flags/search',
        Object.assign(
          { filters: filters },
          typeof payloadOrEvent === 'KeyboardEvent' ? {} : payloadOrEvent
        )
      )
    },
  },
}
</script>
